/* globals Qforms */

window['qforms#show'] =
  window['qforms#edit'] = function () {
    const contractingPositions = $('[data-contracting]').data('contracting')

    const permanentEmploymentFields = [
      '.qform-salary_last',
      '.qform-salary_desired',
      '.qform-max_variation',
      '.qform-ready_to_move',
      '.qform-willing_to_travel',
      '.qform-distance',

      '.qform-company_car',
      '.qform-notice',
      '.qform-appointing_from'
    ].join(', ')

    const freelanceFields = [
      '.qform-available_from',
      '.qform-weekday',
      '.qform-day_month',
      '.qform-minimum_rate',
      '.qform-all_in'
    ].join(', ')

    const onEmploymentModeChanged = (_event) => {
      const newEmploymentMode = $('#qform_employment_mode').val()
      const isEmptyMode = newEmploymentMode === '' || newEmploymentMode === null || newEmploymentMode === undefined
      const isContracingPosition = contractingPositions.indexOf(newEmploymentMode) !== -1

      if (isEmptyMode) {
        $(freelanceFields).removeClass('hidden')
        $(permanentEmploymentFields).removeClass('hidden')
      } else if (isContracingPosition) {
        $(freelanceFields).removeClass('hidden')
        $(permanentEmploymentFields).addClass('hidden')
      } else {
        $(freelanceFields).addClass('hidden')
        $(permanentEmploymentFields).removeClass('hidden')
      }

      Qforms.hideEmptyGroups()
    }

    onEmploymentModeChanged()

    $('#qform_employment_mode').on('change', onEmploymentModeChanged)

    Qforms.initHints()
  }
